<template>
  <div
    class="fe-video-component"
    :style="{ width: (type === 'inline' ? width : 0) + 'px', height: (type === 'inline' ? height : 0) + 'px' }"
  >
    <template v-if="type === 'inline'">
      <div class="video-inline-bg">
        <VideoPlayer v-if="reloadRender" ref="videoRef" :options="options"> </VideoPlayer>
      </div>
    </template>
    <template v-else>
      <div
        v-show="showDialog"
        class="video-mask feupload__animated feupload__fadeIn"
        :class="{ feupload__fadeOut: isClosing }"
        @click="handleMaskClick"
      ></div>
      <div
        v-show="showDialog"
        class="video-dialog feupload__animated feupload__zoomIn"
        :class="{ feupload__zoomOut: isClosing }"
        :style="{
          width: width + 'px',
          height: height + 'px',
          marginLeft: -width / 2 + 'px',
          marginTop: -height / 2 + 'px'
        }"
      >
        <VideoPlayer v-if="reloadRender" ref="videoRef" :options="options"> </VideoPlayer>
      </div>
    </template>
  </div>
</template>
<script>
import VideoPlayer from './VideoPlayer.vue';
export default {
  name: 'FeVideo',
  components: { VideoPlayer },
  props: {
    type: {
      required: false,
      type: String,
      default: 'dialog',
      validator: function (value) {
        // inline页面直接显示 dialog弹出显示
        return ['inline', 'dialog'].indexOf(value) !== -1;
      }
    },
    width: {
      required: false,
      type: Number,
      default: 540
    },
    height: {
      required: false,
      type: Number,
      default: 360
    },
    options: {
      required: false,
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      reloadRender: true, // 修改options后 需要重新初始化viodejs
      showDialog: false,
      isClosing: false // 关闭中状态 加动画
    };
  },
  watch: {
    options: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        if (this.type === 'inline') {
          this.reloadRender = false;
          setTimeout(() => {
            this.reloadRender = true;
          }, 0);
        }
        if (newValue.source && newValue.source.length) {
          this.openDialog();
        }
      }
    }
  },
  methods: {
    handleMaskClick() {
      this.closeDialog();
    },
    openDialog() {
      this.showDialog = true;
      this.reloadRender = false;
      setTimeout(() => {
        this.reloadRender = true;
        this.$nextTick(() => {
          this.handlePlay();
        });
      }, 350);
    },
    closeDialog() {
      this.isClosing = true;
      setTimeout(() => {
        this.isClosing = false;
        this.handleStop();
        this.showDialog = false;
      }, 350);
    },
    handlePlay() {
      this.$refs.videoRef.onPaly();
    },
    handleStop() {
      this.$refs.videoRef.onStop();
    }
  }
};
</script>

<style lang="postcss">
.fe-video-component {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;

  .video-mask {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.1);
    z-index: 7000;
  }
  .video-dialog {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 50%;
    top: 38%;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    background-color: #000000;
    z-index: 7100;
  }
  .video-inline-bg {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    vertical-align: middle;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-size: contain;
    background-color: #000000;
    flex: 1 1 auto;
  }
  .feupload__animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-duration: var(--animate-duration);
    animation-duration: var(--animate-duration);
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .feupload__animated {
    -webkit-animation-duration: 0.3s;
    animation-duration: 0.3s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .feupload__fadeIn {
    -webkit-animation-name: UploadFadeIn;
    animation-name: UploadFadeIn;
  }

  .feupload__fadeOut {
    -webkit-animation-name: UploadFadeOut;
    animation-name: UploadFadeOut;
  }

  .feupload__zoomIn {
    -webkit-animation-name: UploadZoomIn;
    animation-name: UploadZoomIn;
  }

  .feupload__zoomOut {
    -webkit-animation-name: UploadZoomOut;
    animation-name: UploadZoomOut;
  }

  @keyframes UploadFadeIn {
    0% {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
  @keyframes UploadFadeOut {
    0% {
      opacity: 1;
    }

    to {
      opacity: 0;
    }
  }
  @keyframes UploadZoomIn {
    0% {
      opacity: 0;
      -webkit-transform: scale3d(0.3, 0.3, 0.3);
      transform: scale3d(0.3, 0.3, 0.3);
    }

    50% {
      opacity: 1;
    }
  }
  @keyframes UploadZoomOut {
    0% {
      opacity: 1;
    }

    50% {
      opacity: 0;
      -webkit-transform: scale3d(0.3, 0.3, 0.3);
      transform: scale3d(0.3, 0.3, 0.3);
    }

    to {
      opacity: 0;
    }
  }
}
</style>
